package ai.wagemix.logic.sharedmix

import ai.wagemix.net.models.WMBadge
import co.touchlab.kermit.Severity
import com.fsryan.foundation.util.log.FSLog
import com.fsryan.foundation.util.log.sendEventInclusive

/*
 * The analytics events of the shared mix presenter (planning/analytics-plan.md §5, "Saved and
 * shared mixes").
 */

/**
 * [mixId] is the shared mix's id from the link. [viewerIsOwner] is `true` when the signed-in viewer
 * created this link on this device (the shared document does not name its owner).
 */
internal fun FSLog.sendWMSharedMixViewed(mixId: String, badgeTier: WMBadge, viewerIsOwner: Boolean) {
    sendEventInclusive(severity = Severity.Info, eventName = "WMSharedMixViewed") {
        put("mix_id", mixId)
        put("badge_tier", badgeTier.name)
        put("viewer_is_owner", viewerIsOwner)
    }
}
